import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import s from './badge-tooltip.module.scss';

interface VerifiedByWixBadgeProps {
  showBorder?: boolean;
  size?: 'tiny' | 'small' | 'medium';
}

export function VerifiedByWixBadge({
  showBorder,
  size = 'tiny',
}: VerifiedByWixBadgeProps) {
  const { t } = useEssentials();

  return (
    <Badge
      skin="neutralStandard"
      type="outlined"
      dataHook="verified-by-wix-badge"
      uppercase={false}
      showBorder={showBorder}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          <Text
            size="small"
            weight="bold"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('wix.verified.badge')}
          </Text>
          <Text
            size="small"
            weight="thin"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('wix.verified.badge.tooltip')}
          </Text>
        </Box>
      }
    >
      <Box fontSize={size === 'medium' ? 'small' : 'tiny'}>
        {t('wix.verified.badge')}
      </Box>
    </Badge>
  );
}
